import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import api from "../../configs/api";
import { useNavigate } from "react-router-dom";

const SuperAdminAdvertisements = () => {
  const [ads, setAds] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch ads initially
  const fetchAds = async () => {
    try {
      const { data } = await api.get("/advertisements");
      setAds(data);
    } catch (err) {
      console.error("Error fetching ads:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAds();
  }, []);

  const handleAdChange = (type) => {
    navigate(`upsert?type=${type}`);
  };

  const renderImageBlock = (url) => (
    <div className="relative w-full aspect-[356/390] max-w-[356px]">
      <div className="absolute inset-0">
        {loading || !url ? (
          <div className="animate-pulse bg-gray-200 rounded-lg w-full h-full" />
        ) : (
          <img
            alt=""
            src={url}
            className="w-full h-full object-cover rounded-lg"
          />
        )}
      </div>
    </div>
  );

  return (
    <div className="p-6 w-full animate-fade-in">
      <h1 className="text-2xl font-semibold mb-6 text-gray-800">
        Manage Advertisements
      </h1>

      {/* Grid Layout */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* TOP AD CARD */}
        <div className="bg-white rounded-xl flex flex-col items-center justify-center shadow border p-5 relative">
          <h2 className="text-lg font-medium text-gray-700 mb-3">
            Top Advertisement
          </h2>

          {renderImageBlock(ads?.topAdUrl)}

          <button
            onClick={() => handleAdChange("top")}
            className="mt-4 flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition"
            disabled={loading}
          >
            <RefreshCw size={18} />
            Update Ad
          </button>
        </div>

        {/* BOTTOM AD CARD */}
        <div className=" rounded-xl flex flex-col items-center justify-center shadow border p-5 relative">
          <h2 className="text-lg font-medium text-gray-700 mb-3">
            Bottom Advertisement
          </h2>

          {renderImageBlock(ads?.bottomAdUrl)}

          <button
            onClick={() => handleAdChange("bottom")}
            className="mt-4 flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition"
            disabled={loading}
          >
            <RefreshCw size={18} />
            Update Ad
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminAdvertisements;

// import React, { useEffect, useState } from "react";
// import { Loader2, RefreshCw } from "lucide-react";
// import api from "../../configs/api";
// import { useNavigate } from "react-router-dom";

// const SuperAdminAdvertisements = () => {
//   const [ads, setAds] = useState(null);
//   const navigate = useNavigate();

//   // Fetch ads initially
//   const fetchAds = async () => {
//     try {
//       const { data } = await api.get("/advertisements");
//       setAds(data);
//     } catch (err) {
//       console.error("Error fetching ads:", err);
//     }
//   };

//   useEffect(() => {
//     fetchAds();
//   }, []);

//   const handleAdChange = (type) => {
//     navigate(`upsert?type=${type}`);
//   };

//   if (!ads) {
//     return (
//       <div className="flex items-center justify-center h-full">
//         <Loader2 className="w-8 h-8 animate-spin text-purple-500" />
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 w-full animate-fade-in">
//       <h1 className="text-2xl font-semibold mb-6 text-gray-800">
//         Manage Advertisements
//       </h1>

//       {/* Grid Layout */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//         {/* TOP AD CARD */}
//         <div className="bg-white rounded-xl shadow border p-5 relative">
//           <h2 className="text-lg font-medium text-gray-700 mb-3">
//             Top Advertisement
//           </h2>

//           <div className="border rounded-lg overflow-hidden bg-gray-100 relative h-48 flex items-center justify-center">
//             <img
//               alt=""
//               src={
//                 ads.topAdUrl || "https://via.placeholder.com/800x300?text=No+Ad"
//               }
//               className="w-full h-full object-cover"
//             />
//           </div>

//           <button
//             onClick={() => handleAdChange("top")}
//             className="mt-4 flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition"
//           >
//             <RefreshCw size={18} />
//             Update Ad
//           </button>
//         </div>

//         {/* BOTTOM AD CARD */}
//         <div className="bg-white rounded-xl shadow border p-5 relative">
//           <h2 className="text-lg font-medium text-gray-700 mb-3">
//             Bottom Advertisement
//           </h2>

//           <div className="border rounded-lg overflow-hidden bg-gray-100 relative h-48 flex items-center justify-center">
//             <img
//               alt=""
//               src={
//                 ads.bottomAdUrl ||
//                 "https://via.placeholder.com/800x300?text=No+Ad"
//               }
//               className="w-full h-full object-cover"
//             />
//           </div>

//           <button
//             onClick={() => handleAdChange("bottom")}
//             className="mt-4 flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition"
//           >
//             <RefreshCw size={18} />
//             Update Ad
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SuperAdminAdvertisements;
